class Description {
    constructor(reset) {
        var that = this;

        return this.reset(reset);
    }

    reset(reset) {
        $('#event_description').removeClass('transition').css('height', 'auto');
        $('#full-description').removeClass('collapse').css('display', 'none').unbind('click');
        this.fullDescriptionShown = true;

        if(reset) return;

        if($('#event_description').outerHeight() >= 180) {
            this.fullDescriptionShown = false;

            $('#event_description').css('height', '100px');
            $('#full-description').css('display', 'block').bind('click', function() {
                (!that.fullDescriptionShown) ? that.expandDescription() : that.collapseDescription();
                return false;
            });
        }
    }

    expand(noTransition) {
        var that = this;
        this.fullDescriptionShown = true;

        this.descriptionHeight = 0;
        $('p', '#event_description').each(function() {
            that.descriptionHeight += $(this).outerHeight();
        });

        $('#full-description').addClass('collapse');

        (noTransition) ? $('#event_description').removeClass('transition') : $('#event_description').addClass('transition');
        $('#event_description').css('height', this.descriptionHeight);
    }

    collapse() {
        this.fullDescriptionShown = false;

        $('#full-description').removeClass('collapse');
        $('#event_description').addClass('transition').css('height', '100px');
    }
}

export { Description }
